import _Cancel from "@mui/icons-material/Cancel";
import _CheckCircle from "@mui/icons-material/CheckCircle";
import _RemoveCircle from "@mui/icons-material/RemoveCircle";
import { COLORS } from '@fupa/fupa-uikit';
import React from 'react';
export let Result = /*#__PURE__*/function (Result) {
  Result["Win"] = "win";
  Result["Loss"] = "loss";
  Result["Draw"] = "draw";
  return Result;
}({});
const mapResultToIcon = {
  [Result.Draw]: id => /*#__PURE__*/React.createElement(_RemoveCircle, {
    key: id,
    sx: {
      color: COLORS.grey
    },
    fontSize: 'small'
  }),
  [Result.Win]: id => /*#__PURE__*/React.createElement(_CheckCircle, {
    key: id,
    sx: {
      color: COLORS.lightGreen
    },
    fontSize: 'small'
  }),
  [Result.Loss]: id => /*#__PURE__*/React.createElement(_Cancel, {
    key: id,
    sx: {
      color: COLORS.lightRed
    },
    fontSize: 'small'
  })
};
const getFormStandingsLastResults = lastResults => lastResults === null || lastResults === void 0 ? void 0 : lastResults.map((lastResult, id) => {
  return mapResultToIcon[lastResult](id);
});
export default getFormStandingsLastResults;